// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kind-detail-sub {
    margin-top: 0;
    color: var(--dunkelgruen);
    opacity: 0.85;
}

.einheit-block {
    margin-bottom: 2rem;
}

.einheit-titel {
    display: flex;
    align-items: baseline;
    gap: 0.6rem;
    margin-bottom: 0.25rem;
}

.einheit-datum {
    font-size: 0.7em;
    opacity: 0.7;
    font-family: 'Circular', sans-serif;
}

/* Erfüllter Wunsch hervorheben */
.ci-table tbody tr.wunsch-erfuellt td {
    background-color: var(--dunkelgruen);
    color: var(--weiss);
    font-weight: 600;
}

.wunsch-haken {
    white-space: nowrap;
}

/* Nicht erfüllte Wünsche ausgrauen, sobald ein Job zugeteilt wurde */
.ci-table tbody tr.wunsch-ausgegraut td {
    opacity: 0.45;
}

.zugeteilter-job-hinweis {
    background-color: var(--gelb);
    color: var(--dunkelgruen);
    border-radius: 12px;
    padding: 0.75rem;
    margin-bottom: 0.75rem;
}

.keine-wuensche,
.kein-job-hinweis {
    font-style: italic;
    opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/components/jobs/kinderliste/KindDetail.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mCAAmC;AACvC;;AAEA,iCAAiC;AACjC;IACI,oCAAoC;IACpC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,qEAAqE;AACrE;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;AAChB","sourcesContent":[".kind-detail-sub {\n    margin-top: 0;\n    color: var(--dunkelgruen);\n    opacity: 0.85;\n}\n\n.einheit-block {\n    margin-bottom: 2rem;\n}\n\n.einheit-titel {\n    display: flex;\n    align-items: baseline;\n    gap: 0.6rem;\n    margin-bottom: 0.25rem;\n}\n\n.einheit-datum {\n    font-size: 0.7em;\n    opacity: 0.7;\n    font-family: 'Circular', sans-serif;\n}\n\n/* Erfüllter Wunsch hervorheben */\n.ci-table tbody tr.wunsch-erfuellt td {\n    background-color: var(--dunkelgruen);\n    color: var(--weiss);\n    font-weight: 600;\n}\n\n.wunsch-haken {\n    white-space: nowrap;\n}\n\n/* Nicht erfüllte Wünsche ausgrauen, sobald ein Job zugeteilt wurde */\n.ci-table tbody tr.wunsch-ausgegraut td {\n    opacity: 0.45;\n}\n\n.zugeteilter-job-hinweis {\n    background-color: var(--gelb);\n    color: var(--dunkelgruen);\n    border-radius: 12px;\n    padding: 0.75rem;\n    margin-bottom: 0.75rem;\n}\n\n.keine-wuensche,\n.kein-job-hinweis {\n    font-style: italic;\n    opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
